import styled from 'styled-components';
import { Text } from 'components/Atoms';
import { NAVBAR_INDEX } from 'utils/constants';
import { ReactComponent as Cross } from 'assets/iconsOld/cross.svg'

export const Layout = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: ${props => props.theme.old.effects.gray};
  backdrop-filter: ${props => props.theme.old.effects.blur};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${NAVBAR_INDEX + NAVBAR_INDEX};
`;

export const Modal = styled.div`
  min-height: 480px;
  max-width: 800px;
  width: 90%;
  background-color: ${props => props.theme.old.colors.primary};
  background-image: url(${props => props.bgImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 48px;
  border-radius: ${props => props.theme.old.rounded.sm};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: relative;

  ${({ theme }) => theme.old.breakpoints.isTab}{
    grid-template-columns: repeat(1, 1fr);
    min-height: fit-content;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  grid-gap: 16px;
`;

export const Right = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-gap: 16px;
`;

export const Title = styled(Text)`
  font-size: ${props => props.theme.old.fontSize.subtitle};
  font-weight: ${props => props.theme.old.fonts.weight.semibold};
  text-align: center;
  margin-top: 20px;
`;

export const Close = styled(Cross)`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 32px;
  right: 32px;
  cursor: pointer;

  path {
    fill: ${props => props.theme.old.colors.white};
  }
`;